import { useMemo } from 'react';
import useSelectedTheme from '@rsos/hooks/useSelectedTheme';
import { DARK_THEME } from '@rsos/theme/constants';
import { getGoogleMapIdDark, getGoogleMapIdLight } from '@rsos/utils/metaTags';

const googleMapIdDark = getGoogleMapIdDark();

const googleMapIdLight = getGoogleMapIdLight();

/**
 * Memoizes the Google Map ID based on the current theme
 * - For dark themes (`DARK_THEME`), returns `googleMapIdDark`.
 * - For light themes, returns `googleMapIdLight`.
 * @returns String
 */
const useGoogleMapId = () => {
  const themeName = useSelectedTheme();

  const googleMapId = useMemo(() => {
    if (themeName === DARK_THEME) {
      return googleMapIdDark;
    }
    return googleMapIdLight;
  }, [themeName]);

  return googleMapId;
};

export default useGoogleMapId;
